import { getOpxHostApi } from './getOpxHostApi';
import { Feature } from './OpxHostApi';

import { hasQueryStringParameter } from 'owa-querystring';
import { isHostedInTeams } from './isHostedInTeams';
import { isOpxHostInitialized } from './getOpxHostApi';

export function isFeatureDisabledForOpx(feature: Feature) {
    const isOpx =
        isOpxHostInitialized() ||
        hasQueryStringParameter('hostApp', window.location) ||
        isHostedInTeams();

    return isOpx && getOpxHostApi().isFeatureDisabled(feature);
}
